import { render, staticRenderFns } from "./IconInvestSell.vue?vue&type=template&id=6e79f1a3&scoped=true&"
import script from "./IconInvestSell.vue?vue&type=script&lang=js&"
export * from "./IconInvestSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e79f1a3",
  null
  
)

export default component.exports